export default __webpack_public_path__ + "static/media/02_A.e7ed7718.png";